// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__1jhVk","spinner":"styles_spinner__1dGM8"};